import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken } from "./api";

const AuthCtx = createContext(null);

export function startLogin(next, role) {
  const p = new URLSearchParams();
  if (next) p.set("next", next);
  if (role) p.set("role", role);
  window.location.href = `/login${p.toString() ? `?${p}` : ""}`;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setToken(null);
    setUser(null);
    window.location.href = "/";
  };

  return <AuthCtx.Provider value={{ user, setUser, loading, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (user) =>
  !user ? "/" : user.role === "admin" ? "/admin" : user.role === "employer" ? "/employer" : user.role === "candidate" ? "/jobs" : "/choose-role";
